export default (basketItem) => {
  const {category} = basketItem;
  if (category) {
    const categoriesList = category.split('/');
    const categoriesObj = {};
    categoriesList.forEach((item, idx) => {
      categoriesObj[`item_category${idx === 0 ? '' : idx + 1}`] = item ? item.trim() : '';
    });
    return categoriesObj;
  }
  
  return null;
};
